import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User, TeamMember } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class TeamMembersService {
    constructor(
      private http: HttpClient
    ) { }

    getTeamMembers() {
     let user: any ;
     if (localStorage.getItem('currentUserId')) {
         user = JSON.parse(localStorage.getItem('currentUserId'));
     }
      let params = new HttpParams();
      //params = params.append('team', team_id.toString());
      params = params.append('team', user.team);
      return this.http.get<TeamMember[]>(URL+'pss_app/team-members/', {params: params});
    }
    update(user: User) {
        return this.http.put(URL+'pss_app/users/'+user.id+'/', user);
    }
    delete(id: number) {
        console.log('TeamMembersService:delete');
//        response =  this.http.delete('/api/users/' + id);
        console.log(URL+'pss_app/users/' + id+ '/');
        var response =  this.http.delete(URL+'pss_app/users/' + id + '/');
        console.log(response);
        return response;
    }

    del_user(id: number) {
        console.log('TeamMembersService:del_user');
      let params = new HttpParams();
      params = params.append('id', id.toString());
        var response =  this.http.get(URL+'pss_app/users/', {params: params});
        console.log(response);
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/team-members.service.ts